module.exports = __webpack_public_path__ + "img/question.c7862743.svg";